import axios from 'axios'

const POSABIT_ENDPOINT = process.env.VUE_APP_PAYMENT_ENDPOINT

const POSABIT_API = axios.create({
  baseURL: `${POSABIT_ENDPOINT}check`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true
})

export default POSABIT_API
